import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';
import { PageRoot, PageContent } from './styles';
import Header from './Header';
export default function PageSkeleton() {
    return (
        <PageRoot>
            <Header />
            <PageContent>
                <Box textAlign="center" mb={5}>
                    <Skeleton variant="text" width={320} height={50} sx={{ mx: 'auto' }} />
                    <Skeleton variant="text" width={520} height={26} sx={{ mx: 'auto', mt: 1 }} />
                </Box>
                <Box display="flex" gap={3} mb={3}>
                    <Skeleton variant="rounded" height={200} sx={{ flex: 1, borderRadius: 2 }} />
                    <Skeleton variant="rounded" height={200} sx={{ flex: 1, borderRadius: 2 }} />
                </Box>
                <Grid container spacing={2} sx={{ mb: 3 }}>
                    {[0, 1, 2, 3].map((i) => (
                        <Grid item xs={6} sm={3} key={i}>
                            <Skeleton variant="rounded" height={120} sx={{ borderRadius: 2 }} />
                        </Grid>
                    ))}
                </Grid>
                <Skeleton variant="rounded" height={300} sx={{ borderRadius: 2, mb: 3 }} />
                <Skeleton variant="rounded" height={140} sx={{ borderRadius: 2 }} />
            </PageContent>
        </PageRoot>
    );
}
